/* spreadsheet apps (Excel, Google Sheets, LibreOffice) treat a cell as a
   formula if it starts with one of these characters; prefix it with a
   single quote so it's always treated as plain text instead. Necessary even
   though this CSV is built entirely client-side, since cell values (e.g. a
   student's name) can still originate from user-entered data.
   see: https://owasp.org/www-community/attacks/CSV_Injection */
const FORMULA_TRIGGER_CHARS = new Set(['=', '+', '-', '@', '\t', '\r']);

function neutralizeFormulaInjection(field: string): string {
  return FORMULA_TRIGGER_CHARS.has(field.charAt(0)) ? `'${field}` : field;
}

/* wrap fields containing a comma, quote, or newline in quotes (escaping any
   existing quotes) so they don't get split into extra columns */
function escapeCsvField(field: string): string {
  const safeField = neutralizeFormulaInjection(field);
  if (/[",\n]/.test(safeField)) {
    return `"${safeField.replace(/"/g, '""')}"`;
  }
  return safeField;
}

export function convertToCsv(array: string[][]) {
  // build simple multi-line string from array
  const csvContent = array
    .map((row: string[]) => row.map(escapeCsvField).join(','))
    .join('\n');

  // convert to csv blob
  const blob = new Blob([csvContent], { type: 'text/csv' });
  const objectUrl = URL.createObjectURL(blob);

  return objectUrl;
}

// export const downloadFile = (dataUrl: string, filename: string) => {
export const downloadFile = (dataUrl: string, filename: string) => {
  // build new `a` element with proper attributes
  const downloadCsvLink = document.createElement('a');
  downloadCsvLink.href = dataUrl;
  downloadCsvLink.download = filename;

  // append to document, click, remove right away so layout doesn't change
  document.body.appendChild(downloadCsvLink);
  downloadCsvLink.click();
  document.body.removeChild(downloadCsvLink);
};
